import React from 'react';
import styled from 'styled-components';
import TextBlock from '../../components/TextBlock';
import Highlights from './Highlights/Highlights';
import BuilderSection from './BuilderSection/BuilderSection';
import MouseMosaicBanner from './MouseMosaicBanner/MouseMosaicBanner';
import miceBannerImage768 from './images/miceBanner_768.jpg';
import miceBannerImage1796 from './images/miceBanner_1796.jpg';
import miceBannerImage2560 from './images/miceBanner_2560.jpg';
import miceBanner2Image768 from './images/miceBanner2_768.jpg';
import miceBanner2Image1440 from './images/miceBanner2_1440.jpg';
import miceBanner2Image2560 from './images/miceBanner2_2560.jpg';
import Carousel from './Carousel/Carousel';
import NewsLetterBlock from '../../components/NewsletterBlock';
import Catalogue from './Catalogue/Cataloge';

const HomeStyles = styled.div`
  color: var(--color-white);
  font-size: 2rem;
  font-weight: normal;
  background-color: var(--color-grey-1);

  h1,
  h2,
  h3,
  p {
    margin: 0;
    font-size: 2rem;
    font-weight: normal;
  }

  @media (min-width: 768px) {
    h1,
    h2,
    h3,
    p {
      font-size: 3.5vh;
    }
  }
`;

const ImageBanner = styled.section`
  display: flex;
  justify-content: center;
  img {
    width: 100%;
    object-fit: cover;
  }

  @media (min-width: 768px) {
    max-height: 51.25rem;

    img {
      width: 100%;
      max-height: 88vh;
    }
  }
`;

function Home() {
  return (
    <HomeStyles>
      <TextBlock>
        <h1>
          {
            'Meet Diana, the first fully customizable pro mouse.\nBecause better gamers deserve better tools.'
          }
        </h1>
        <NewsLetterBlock />
      </TextBlock>
      <Carousel />
      <TextBlock>
        <p>
          At Artema we believe each gamer is unique so we offer you a new
          customization paradigm for your peripherals.
        </p>
        <p>
          Our team have great expertise in electronics, mechanics, production
          processes and software. This enable us to create Diana expanding the
          possibilities of customization.
        </p>
      </TextBlock>
      <ImageBanner>
        <img
          sizes="(max-width: 2560px) 100vw, 2560px"
          srcSet={`
            ${miceBannerImage768} 768w,
            ${miceBannerImage1796} 1796w,
            ${miceBannerImage2560} 2560w
            `}
          src={miceBannerImage2560}
          alt="mice statues render"
          loading="lazy"
        />
      </ImageBanner>
      <TextBlock>
        <p>
          We want to empower you to build a unique gaming tool that reflects
          your personality and your gameplay style while covering all the needs
          that you may have as a gamer.
        </p>
      </TextBlock>
      <BuilderSection />
      <TextBlock>
        <p>
          Our proposal consists of enabling a wide selection of options in terms
          of device features, product cosmetics and ergonomics perfectly sized
          for you.
        </p>
      </TextBlock>
      <MouseMosaicBanner />
      <TextBlock>
        <p>
          Choose between 4 different sizes, 24 colors, shell perforated patterns
          and many more features that will come to make your mouse unique.
        </p>
      </TextBlock>
      <ImageBanner>
        <img
          sizes="(max-width: 2560px) 100vw, 2560px"
          srcSet={`
            ${miceBanner2Image768} 768w,
            ${miceBanner2Image1440} 1796w,
            ${miceBanner2Image2560} 2560w
            `}
          src={miceBanner2Image2560}
          alt="mice statues render"
          loading="lazy"
        />
      </ImageBanner>
    </HomeStyles>
  );
}

export default Home;
